export const Item = ({ id, title, url }) => {
  return (
    <>
      <img src={url} alt={title} />
    </>
  );
};
